/* eslint-disable */

import React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import { MainLayout } from '../layouts';

import { SliceZone } from '../components';

export const query = graphql`
  query SolutionsQuery($uid: String!) {
    prismic {
      solutions(lang: "en-us", uid: $uid) {
        _meta {
          lang
          lastPublicationDate
          type
          uid
        }
        body {
        ... on PRISMIC_SolutionsBodyHerotext {
          type
            label
            primary {
              fullscreen
              large_text
              text_color
              background_color
              background_image
              display_primary_cta
              display_secondary_cta
              heading
              primary_cta_color
              primary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              primary_cta_text
              secondary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              secondary_cta_text
              subheading
              text_alignment
            }
        },
        ... on PRISMIC_SolutionsBodyCardsv2 {
          type
            label
            fields {
              image
              link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              text
              text_color
              title1
              title_color
            }
            primary {
              background_color
              columns
              content_alignment
              cta_button_text
              cta_button_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              heading_color
              subheading
              subheading_color
              text_color
              background_image
            }
        },
        ... on PRISMIC_SolutionsBodyCtaband {
          type
            label
            primary {
              text_color
              background_color
              cta_band
              cta_primary_background_color
              cta_text_primary
              cta_text_secondary
              cta_url_primary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              cta_url_secondary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              subheading
              background_image
            }
        },
        ... on PRISMIC_SolutionsBodyVideoquote {
          type
            label
            primary {
              author
              background_color
              background_image
              company
              heading
              heading_color
              logo
              avatar
              position
              quote
              quote_color
              subheading
              subheading_color
              text_color
              wistia_video_id
            }
        },
        ... on PRISMIC_SolutionsBodyCarouseltestimonial {
          type
            label
            primary {
              background_color
              background_image
              text_color
              heading
              heading_color
              subheading1
              subheading_color
            }
            fields {
              logo
              quote
              author
              author_details
              avatar
              link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_text
            }
        },
        ... on PRISMIC_SolutionsBodyFeatureslist {
          type
            label
            primary {
              background_color
              background_image
              cta_button_color
              cta_button_text
              cta_button_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              item_text_color
              heading_color
              item_title_color
              subheading
              subheading_color
              text_color
            }
            fields {
              item_icon
              item_text
              item_title
            }
        },
        ... on PRISMIC_SolutionsBodyCarouselcards {
          type
            label
            fields {
              image
              text
              text_color
              title1
              title_color
            }
            primary {
              background_color
              background_image
              cards_per_page
              cta_button_text: cta_text
              cta_button_link: cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              heading_color
              subheading
              subheading_color
              text_color
            }
        },
        ... on PRISMIC_SolutionsBodyCarouselimage {
          type
            primary {
              background_color
              background_image
              text_color
              heading
              heading_color
              subheading
              subheading_color
            }
            fields {
              image
              image_text
              image_text_color
            }
        },
        ... on PRISMIC_SolutionsBodyListalternatingv2 {
          type
            label
            fields {
              list_alt_image
              list_alt_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              list_alt_link_text
              list_alt_text
              list_alt_title
              list_link_color
              list_text_color
              list_title_color
            }
            primary {
              background_color
              heading
              subheading
              background_image
              heading_color
              subheading_color
              text_color
            }
        },
        ... on PRISMIC_SolutionsBodyListgridv2 {
          type
            label
            primary {
              background_color
              background_image
              heading
              heading_color
              list_column_number
              list_item_alignment_position
              list_item_heading_color
              list_item_text_color
              list_item_icon_position
              list_item_icon_size
              subheading
              subheading_color
              text_color
              cta_button_text
              cta_button_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              annotation
            }
            fields {
              list_item_heading
              list_item_icon
              list_item_text
              list_item_url_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              list_item_url_text
            }
        },
        ... on PRISMIC_SolutionsBodyContentblock {
          type
            label
            primary {
              target_name
              background_color
              background_image
              content
              content_text_alignment
              heading
              heading_color
              image
              subheading
              subheading_color
              text_color
              wistia_id
            }
        },
        ... on PRISMIC_SolutionsBodyToptabbednavcontent {
            type
  label
  fields {
    image
    link_color
    tab_icon
    tab_label
    text
    text_color
    title1
    title_color
    content_link_text
    link_url {
      _linkType
      ... on PRISMIC__ExternalLink {
        _linkType
        url
      }
    }
    image_position
  }
  primary {
    background_color
    heading_color
    heading
    subheading
    subheading_color
    text_color
  }

        },
        ... on PRISMIC_SolutionsBodyDynamicformbuilder {
          type
          label
          primary {
            footer_form_text
            form_anchor_name
            form_post_location
            header_form_text
            marketo_form_id
            munchkin_account_id
            sub_header_form_text
            thank_you_message
            analytics_track
            analytics_action
          }
          fields {
            field_alphanumeric
            field_column_width
            field_error_message
            field_max_length
            field_name
            field_placeholder
            field_post_name
            field_required
            field_type
            field_value
            section_header
            section_sub_header
          }
        }}
        date
        description
        path
        title
        open_graph_image
      }
    }
  }
`;

const Solutions = ({ data, location }) =>
  data.prismic.solutions ? (
    <MainLayout location={location} layout='solutions'>
    <Helmet>
      <title>{(data.prismic.solutions.title[0] && data.prismic.solutions.title[0].text) || 'DigitalOcean'}</title>
      <link rel="canonical" href={data.prismic.solutions.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.solutions.path : 'https://www.digitalocean.com' + data.prismic.solutions.path + '/'} />
      <meta
        name="description"
        content={
          data.prismic.solutions.description ||
          'Helping millions of developers easily build, test, manage, and scale applications of any size – faster than ever before.'
        }
      />
      <meta name="twitter:card" content="summary"/>
      <meta name="twitter:title" content={data.prismic.solutions.title[0] ? data.prismic.solutions.title[0].text : 'DigitalOcean'} />
      <meta name="twitter:description" content={data.prismic.solutions.description ? data.prismic.solutions.description : 'DigitalOcean'} />
      <meta name="twitter:image" property={data.prismic.solutions.open_graph_image ? data.prismic.solutions.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={data.prismic.solutions.description ? data.prismic.solutions.description : 'DigitalOcean'} />
      <meta property="og:title" content={data.prismic.solutions.title[0] ? data.prismic.solutions.title[0].text : 'DigitalOcean'} />
      <meta property="og:url" content={data.prismic.solutions.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.solutions.path : 'https://www.digitalocean.com' + data.prismic.solutions.path + '/'} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="600" />
      <meta property="og:image" content={data.prismic.solutions.open_graph_image ? data.prismic.solutions.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
    </Helmet>
      <SliceZone allSlices={data.prismic.solutions.body} />
    </MainLayout>
  ) : null;

Solutions.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Solutions;
